import { render, staticRenderFns } from "./icon-arrow-rounded.vue?vue&type=template&id=47761834&scoped=true&"
import script from "./icon-arrow-rounded.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-rounded.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow-rounded.vue?vue&type=style&index=0&id=47761834&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47761834",
  null
  
)

export default component.exports